import React, { useEffect, useState } from 'react';
import { ShoppingBag } from 'lucide-react';
const NAMES = ['María', 'Lucía', 'Sofía', 'Valentina', 'Camila', 'Martina', 'Julieta', 'Paula'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Tucumán'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Show for 4 seconds
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 5000);
    // Repeat every 8-12 seconds
    const interval = setInterval(() => {
      // Random delay between 8 and 12 seconds
      const delay = 8000 + Math.random() * 4000;
      setTimeout(showPopup, delay);
    }, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up" data-id="element-7">
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-center gap-3 border-l-4 border-orange-400 max-w-xs" data-id="element-8">
        <div className="bg-orange-100 p-2 rounded-full" data-id="element-9">
          <ShoppingBag className="w-5 h-5 text-orange-600" data-id="element-10" />
        </div>
        <div data-id="element-11">
          <p className="text-sm font-medium text-gray-900" data-id="element-12">
            {data.name} de {data.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-13">
            acaba de comprar este libro digital
          </p>
        </div>
      </div>
    </div>;
}